<div class="cont">
    <H2 class="head">{{'provisions.head'|translate}}</H2>
    
</div>
<docs-table [translations]="translations"></docs-table>
